import React from 'react';
import { useTenant } from '../../contexs/tenant-context';
import { VendorOrderNotification } from './vendor-order-notification';
import { CashRegisterOrderNotification } from './cash-register-order-notification';

export const OrderNotification = () => {
  const { tenant } = useTenant();

  // Choose the correct notification component based on the tenant plan
  const OrderNotificationComponent = tenant.plan.cash_register_enabled
    ? CashRegisterOrderNotification
    : VendorOrderNotification;

  return <OrderNotificationComponent />;
};
